export { AppAttendance } from './attendanceApp/attendance';
export { MyAttendance } from './myattendance/page';
export { Employee } from './employee/page';

// Page crud
export { AddAttendance } from './add_attendance/page';
export { DetailAttendance } from './detail_attendance/page';




// WEBPACK FOOTER //
// ./src/pages/attendance/index.ts